export default {
      id: "usp-wealth-creation-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#usp-wealth-creation",
      toString: function () {
        return this.url;
      }
    }